import styled from 'styled-components'
import React, {Component} from 'react';
import FieldError from "./FieldError";


const InputContainer = styled.div`
margin: 1rem auto;
display: block;
position:relative;
width: 80%;
border-radius: 20px;
overflow: ${props => props.overflow ? props.overflow : 'auto'};
//outline: ${props => props.error ? 'red solid 3px' : 'none'};
box-sizing: border-box;

`

export const CustomInputField = styled.input`
width: 100%;
padding: 1rem 2rem;
font-family: 'Roboto', sans-serif;
font-style: normal;
font-weight: normal;
font-size: 1.2rem;
line-height: 1.4rem;
text-align: center;
text-align-last: center;
text-transform: ${props => props.textTransform ? props.textTransform : 'uppercase'};
color: #292929;
//margin: 1rem auto;
display: block;
border: none;
//border-style: none;
//border: ${props => props.error ? 'red solid 3px' : 'none'};
border-radius: 20px;
background-color: ${props => props.disabled ? '#eaeaea' : '#ffffff'};
box-sizing: border-box;
&:focus {
outline: none;
}
&::placeholder {
text-transform: uppercase;
}
`

export const ErrorIndicatorDiv = styled.div`
  width: 100%;
  height: 100%;
  background-color: transparent;
  position: absolute;
  bottom: 0;
  border: #dc9292 solid 3px;
  pointer-events: none;
  box-sizing: border-box;
  border-radius: 20px;
`


export class CustomInput extends Component {
    render() {

        if (this.props.error) {
            return (
                <div style={{position: 'relative'}}>
                    <InputContainer>
                        <CustomInputField {...this.props} autoComplete={'off'}/>
                        {this.props.error ?
                            <ErrorIndicatorDiv/>
                            :
                            null
                        }
                    </InputContainer>
                    <FieldError error={this.props.error}/>

                </div>
            )
        }
        return (
            <div style={{position: 'relative'}}>

                <InputContainer>
                    <CustomInputField {...this.props} autoComplete={'off'}/>
                </InputContainer>
                <FieldError/>

            </div>


        );
    }
}

